<template>
  <div>
    <div class="header-img">
      <div class="header-text">
        <h1>派单服务平台</h1>
        <h2>Dispatch order service platform</h2>
      </div>
    </div>
    <div class="crumbs-contain">
      <div>
        您的位置：
        <router-link tag="a" to="Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="Service" class="new-name"
          >派单服务平台</router-link
        >
      </div>
    </div>
    <div class="innovative-service">
      <h1 class="server-text">创新服务</h1>
      <h2 class="server-below">INNOVATIVE SERVICE</h2>
      <div class="server-contain">
        <div class="server-chunk" v-for="(item, index) in Data" :key="index">
          <div><img :src="item.img" :alt="item.title" /></div>
          <div>{{ item.title }}</div>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="serviceImg-contain"></div>
    <div class="sendorders-contain">
      <div class="service-left">
        <h1>服务派单平台介绍</h1>
        <h2>Platform introduction</h2>
        <div>
          我们是为企业客户提供端到端服务的智能运营平台，通过基于云服务平台和大数据分析，实现服务派单的智能化、扁平化，为所有使用平台的企业用户提供专业、标准和可视化的上门服务，可以少建甚至不建高成本的全国服务网络，让资源更多的投入到主业创新和业务拓展中。
        </div>
      </div>
      <div class="service-right">
        <div class="service-concept">
          <div class="concept-left">
            <h1>服务理念</h1>
            <h2>Platform introduction</h2>
          </div>
          <div class="concept-right">
            <img src="../../../static/images/icon8.png" alt="服务理念" />
          </div>
        </div>
        <div class="service-text">不养人</div>
        <div class="service-text">不建库</div>
        <div class="service-text">用户的服务自己做！</div>
      </div>
    </div>
    <div class="operationMode-contain">
      <h1 class="operationMode-title">运作模式</h1>
      <h2 class="operationMode-name">OPERATION PATTERN</h2>
      <div class="operationImg-contain">
        <div class="operation-left">
          <img src="../../../static/images/server12.png" alt="运作模式" />
          <div class="Service-classification">服务分级</div>
        </div>
        <div class="operation-right">
          <div>
            沉淀近20年服务经验的2万名工程师，根据行业选择适合的工程师提供现场服务。
          </div>
          <div>行业内（外）大量服务需求，可补充工程师工作量。</div>
          <div>根据用户要求，共同创建服务流程。</div>
          <div>服务流程固化在系统上，不按流程，做不下去。</div>
          <div>我们的工程师全部是正规的企业员工。</div>
        </div>
      </div>
    </div>
    <div class="underline1"></div>
    <div class="securitySystem-contain">
      <h1 class="securitySystem-title">保障体系</h1>
      <h2 class="securitySystem-name">SECURITY SYSTEM</h2>
      <div class="security-contain">
        <div class="security">
          <div class="security-title">配件管理保障体系</div>
          <div class="security-name">用户自有配件或配件合作库运营保障</div>
          <div class="underline2"></div>
          <div class="system-title">技术支持保障体系</div>
          <div class="underline2"></div>
          <div class="system-warp">
            <div
              class="system-chunk"
              v-for="(item, index) in systemData1"
              :key="index"
              :class="item.className"
            >
              <img :src="item.img" :alt="item.name" />
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="security">
          <div class="security-title">重大项目保障体系</div>
          <div class="security-name">
            成立项目组，负责项目各流程的实施、指导和监督
          </div>
          <div class="underline2"></div>
          <div class="system-title">应急预案保障体系</div>
          <div class="underline2"></div>
          <div class="system-warp">
            <div
              class="system-chunk"
              v-for="(item, index) in systemData2"
              :key="index"
              :class="item.className"
            >
              <img :src="item.img" :alt="item.name" />
              <div>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  data() {
    return {
      Data: [
        {
          img: "../../../static/images/icon4.png",
          title: "服务分级管理",
          name: "Service classification management"
        },
        {
          img: "../../../static/images/icon5.png",
          title: "固化服务流程",
          name: "Curing service process"
        },
        {
          img: "../../../static/images/icon6.png",
          title: "流程节点可控",
          name: "Controllable process node"
        },
        {
          img: "../../../static/images/icon7.png",
          title: "远程智能支持",
          name: "Remote intelligent support"
        }
      ],
      systemData1: [
        {
          img: "../../../static/images/icon9.png",
          name: "电话技术支持远程指导",
          className: ""
        },
        {
          img: "../../../static/images/icon10.png",
          name: "现场技术支持解决指导",
          className: "stytemtrunk"
        },
        {
          img: "../../../static/images/icon11.png",
          name: "专案小组讨论分析",
          className: ""
        },
        {
          img: "../../../static/images/icon12.png",
          name: "疑难杂症入库参考",
          className: "stytemtrunk"
        }
      ],
      systemData2: [
        {
          img: "../../../static/images/icon13.png",
          name: "重大事件及时反馈",
          className: ""
        },
        {
          img: "../../../static/images/icon14.png",
          name: "工作小组制定方案",
          className: "stytemtrunk"
        },
        {
          img: "../../../static/images/icon15.png",
          name: "现场跟进直至闭环",
          className: ""
        }
      ]
    };
  },
  created() {},

  methods: {}
};
</script>

<style scoped lang="less">
.header-img {
  width: 100%;
  height: 300px;
  background: url(../../../static/images/server10.png) no-repeat center center;
  .header-text {
    width: 1170px;
    margin: 0 auto;
    padding-top: 100px;
    h1 {
      color: #3488ea;
      font-size: 28px;
      font-weight: 300;
      line-height: 0;
    }
    h2 {
      color: #464646;
      font-size: 24px;
      opacity: 0.9;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
    }
  }
}
.crumbs-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 30px 0;
  color: #666666;
  font-size: 12px;
  .home-title {
    cursor: pointer;
    color: #666666;
    &:hover {
      color: #3488ea;
    }
  }
  .new-name {
    color: #3488ea;
    cursor: pointer;
  }
  .fa-angle-right {
    margin: 0 5px;
  }
}
.innovative-service {
  width: 1170px;
  margin: 0 auto;
  margin-top: 60px;
  .server-text {
    text-align: center;
    color: #444444;
    font-size: 24px;
    font-weight: 300;
    line-height: 0;
  }
  .server-below {
    text-align: center;
    font-size: 15px;
    color: #666666;
    font-family: "FZCYJ";
    letter-spacing: 1px;
    font-weight: 300;
  }
  .server-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .server-chunk {
      width: 25%;
      height: 300px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      div:nth-of-type(2) {
        color: #444444;
        font-size: 18px;
        font-weight: 300;
        margin-top: 20px;
      }
      div:nth-of-type(3) {
        color: #666666;
        font-size: 13px;
        line-height: 30px;
        font-family: "FZCYJ";
        letter-spacing: 1px;
        text-align: center;
      }
    }
  }
}
.serviceImg-contain {
  width: 100%;
  height: 390px;
  background: url(../../../static/images/server11.png) no-repeat center center;
}
.sendorders-contain {
  width: 1170px;
  height: 335px;
  background: #fff;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.06);
  margin: 0 auto;
  margin-top: -180px;
  .service-left {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 50px;
    box-sizing: border-box;
    h1 {
      font-size: 24px;
      font-weight: 300;
      line-height: 0;
      color: #3488ea;
    }
    h2 {
      font-size: 13px;
      color: #999999;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
      line-height: 0;
    }
    div {
      font-size: 14px;
      font-weight: 300;
      margin-top: 30px;
      color: #999999;
      line-height: 30px;
      letter-spacing: 2px;
    }
  }
  .service-right {
    width: 30%;
    background: #3488ea;
    padding-left: 50px;
    box-sizing: border-box;
    .service-concept {
      width: 100%;
      display: flex;
      flex-direction: row;
      padding-top: 20px;
      .concept-left {
        width: 50%;
        height: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h1 {
          font-size: 24px;
          font-weight: bold;
          line-height: 0;
          color: #ffffff;
        }
        h2 {
          font-size: 13px;
          line-height: 25px;
          color: #ffffff;
          font-family: "FZCYJ";
          line-height: 0;
          letter-spacing: 1px;
          font-weight: 300;
        }
      }
      .concept-right {
        width: 50%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        img {
          width: 112px;
          height: 106px;
        }
      }
    }
    .service-text {
      color: #fff;
      font-size: 20px;
      font-weight: 300;
      line-height: 36px;
    }
  }
}

.operationMode-contain {
  width: 1170px;
  margin: 0 auto;
  margin-top: 90px;
  .operationMode-title {
    text-align: center;
    font-size: 24px;
    font-weight: 300;
    line-height: 0;
    color: #444444;
  }
  .operationMode-name {
    text-align: center;
    font-size: 15px;
    color: #666666;
    font-family: "FZCYJ";
    letter-spacing: 1px;
    font-weight: 300;
  }
  .operationImg-contain {
    width: 100%;
    margin-top: 50px;
    display: flex;
    flex-direction: row;
    .operation-left {
      width: 62%;
      height: 640px;
      position: relative;
      img {
        max-width: 100%;
        height: 640px;
        display: inline-block;
      }
      .Service-classification {
        width: 122px;
        height: 36px;
        color: #444444;
        font-size: 18px;
        text-align: center;
        line-height: 36px;
        background: #f9f9f9;
        font-weight: 300;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    .operation-right {
      width: 38%;
      height: 640px;
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      color: #666666;
      padding-left: 40px;
      box-sizing: border-box;
      div:nth-of-type(1) {
        margin-top: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      div:nth-of-type(2) {
        margin-top: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div:nth-of-type(3) {
        margin-top: 62px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div:nth-of-type(4) {
        margin-top: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div:nth-of-type(5) {
        margin-top: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.underline1 {
  width: 100%;
  height: 1px;
  background: #e5e5e5;
  margin: 80px 0;
}
.securitySystem-contain {
  width: 1170px;
  margin: 0 auto;
  padding-bottom: 100px;
  .securitySystem-title {
    text-align: center;
    font-size: 24px;
    font-weight: 300;
    line-height: 0;
    color: #444444;
  }
  .securitySystem-name {
    text-align: center;
    font-size: 15px;
    color: #666666;
    font-family: "FZCYJ";
    letter-spacing: 1px;
    font-weight: 300;
  }
  .security-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 30px;
    .security {
      width: 46%;
      .security-title {
        font-size: 18px;
        font-weight: 300;
        line-height: 31px;
        color: #444444;
      }
      .security-name {
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
        color: #999999;
        margin-top: 6px;
      }
      .underline2 {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
        margin-top: 13px;
      }
      .system-title {
        font-size: 18px;
        font-weight: 300;
        line-height: 31px;
        color: #444444;
        margin-top: 40px;
      }
      .system-warp {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .system-chunk {
          width: 46%;
          height: 112px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #f9f9f9;
          margin-top: 20px;
          div {
            font-size: 14px;
            font-weight: 300;
            line-height: 24px;
            color: #666666;
            margin-top: 10px;
          }
        }
        .stytemtrunk {
          margin-left: 25px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Service/Service.vue